<template>
  <div :class="$style.imageContainer">
    <img
      ref="image"
      :src="image.url"
      :class="$style.image"
    />
  </div>
</template>

<script>
import { IMAGE_OPTIONS } from '@/lib/consts.js'

const CROPPER_OPTIONS = {
  viewMode: 1,
  aspectRatio: 3 / 2,
  responsive: false,
  dragMode: 'move',
  restore: true,
  guides: true,
  center: false,
  modal: true,
  highlight: false,
  autoCrop: true,
  autoCropArea: 1,
  movable: true,
  scalable: true,
  zoomable: true,
  zoomOnTouch: true,
  zoomOnWheel: true,
  cropBoxMovable: true,
  cropBoxResizable: true,
  background: false,
  toggleDragModeOnDblclick: false,
}

export default {

  emits: [
    'input',
  ],
  props: {

    image: {
      type: Object,
      required: true,
    },

    imageOptions: {
      type: Object,
      default: () => { return IMAGE_OPTIONS },
    },

    cropperOptions: {
      type: Object,
      default: () => { return CROPPER_OPTIONS },
    },
  },

  data () {
    return {
      cropper: null,
    }
  },

  watch: {
    cropperOptions: {
      handler () {
        this.reinitializeCropper()
      },
      deep: true,
    },
  },

  methods: {

    // init cropper
    initCropper () {
      const options = Object.assign(
        {},
        CROPPER_OPTIONS,
        this.cropperOptions
      )
      // lazy import (this component is used occasionally)
      import('cropperjs').then(module => {
        const Cropper = module.default
        this.cropper = new Cropper(
          this.$refs.image,
          options
        )
      })
    },

    // destroy cropper instance
    destroyCropper () {
      if (this.cropper) {
        this.cropper.destroy()
        this.cropper = null
      }
    },

    // reinitialize cropper with new options
    reinitializeCropper () {
      if (this.cropper) {
        this.destroyCropper()
        this.$nextTick(() => {
          this.initCropper()
        })
      }
    },

    // submit cropp area
    submit () {
      const canvas = this.cropper.getCroppedCanvas()

      const type = this.imageOptions.type
      const quality = this.imageOptions.quality

      // blob is not a file, but it's quite similar...
      canvas.toBlob(file => {
        const url = canvas.toDataURL(type, quality)
        this.$emit('input', {
          file,
          url,
        })
      }, type, quality)
    },
  },

  created () {
    // wait for <img/> element...
    this.$nextTick(this.initCropper)
  },

  beforeUnmount () {
    this.destroyCropper()
  },
}
</script>

<style lang="scss" module>
@import '@/assets/stylesheets/typography';

.imageContainer {
  width: 768px;
  height: 512px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.image {
  display: none;
}
</style>
